import React from 'react'
import { Typography } from '@reconvert/react-ui-component'
import { CloseFilled } from '@reconvert/react-ui-component/icons'
import { Flex } from '@chakra-ui/react'

const FieldError = ({ error }: { error: string }) => {
    return (
        <Flex alignItems="center" gap="4px">
            <CloseFilled width="12px" height="12px" color="error.700" />
            <Typography color="red.500" fontSize="xs" variant="small">
                {error}
            </Typography>
        </Flex>
    )
}

export default FieldError